import BaseService from "@/services/BaseService";
import { config, CONFIG } from "@/config";
import crypto from 'crypto'
import BubbleService from "@/services/Bubble/BubbleService";
import { DateTime } from "luxon";

class PaymentService extends BaseService {
    public cancelEndPoint = process.env.NEXT_PUBLIC_SITE_URL + '/application'
    public returnUrlEndPoint = process.env.NEXT_PUBLIC_SITE_URL + '/application'

    constructor() {
        super(config.payOS.endpoint, {
            "x-client-id": config.payOS.clientId,
            "x-api-key": config.payOS.apiKey
        })
    }

    createPaymentLink = async (amount: number, description: string) => {
        const descriptionArr = description.split(' ')
        const contractCode = descriptionArr[0]

        const cancelUrl = `${this.cancelEndPoint}/${contractCode}/overview`
        const returnUrl = `${this.returnUrlEndPoint}/${contractCode}/overview`

        // const expiredTime = DateTime.local().setZone('UTC+7').toFormat('dd/MM/yyy HH:mm')
        let orderCodeNumber = Number(String(new Date().getTime()).slice(-6))
        const data = {
            orderCode: orderCodeNumber,
            amount: amount,
            description: description,
            cancelUrl,
            returnUrl,
            signature: this.createSignature(amount, cancelUrl, description, orderCodeNumber, returnUrl)
        }
        console.log({paymentPayload: data})
        const result = await this.post('/v2/payment-requests', data)
        return result
    }

    getPaymentInfo = async (orderCode: string) => {
        const result = await this.get(`/v2/payment-requests/${orderCode}`)
        return result
    }

    cancelPaymentLink = async (orderCode: string) => {
        const result = await this.get(`/v2/payment-requests/${orderCode}/cancel`)
        return result
    }

    checkWebhookSignature(data: any, currentSignature: any) {
        const sortedDataByKey = this.sortObjDataByKey(data);
        const dataQueryStr = this.convertObjToQueryStr(sortedDataByKey);
        const dataToSignature = crypto.createHmac("sha256", config.payOS.checksumKey)
            .update(dataQueryStr)
            .digest("hex");
        console.log({dataToSignature})
        return dataToSignature == currentSignature;
    }

    createBubbleTransaction = async (data:any) => {
        const bubbleService = new BubbleService()
        const result = await bubbleService.postWf('success_payment_webhook',data)
        return true
    }

    updateSuccessSchedulePayment = async (scheduleCode:string,orderCode:number,amount:number) => {
        const bubbleService = new BubbleService()
        const data = await bubbleService.postWf('update_schedule_when_payment_success',{scheduleCode,orderCode,amount})
    }

    updateEarlySchedulePayment = 
    async (applicationId:string) => {
        const bubbleService = new BubbleService()
        const data = await bubbleService.postWf('update_schedule_when_early_payment',{applicationId})
    }

    private sortObjDataByKey(object: { [key: string]: any }): { [key: string]: any } {
        const orderedObject = Object.keys(object)
            .sort()
            .reduce((obj: { [key: string]: any }, key: string) => {
                obj[key] = object[key];
                return obj;
            }, {});
        return orderedObject;
    }

    private convertObjToQueryStr(object: any) {
        return Object.keys(object)
            .filter((key) => object[key] !== undefined)
            .map((key) => {
                let value = object[key];
                // Sort nested object
                if (value && Array.isArray(value)) {
                    value = JSON.stringify(value.map((val) => this.sortObjDataByKey(val)));
                }
                // Set empty string if null
                if ([null, undefined, "undefined", "null"].includes(value)) {
                    value = "";
                }

                return `${key}=${value}`;
            })
            .join("&");
    }

    createSignature = (amount: number, cancelUrl: string, description: string, orderCode: number, returnUrl: string) => {
        let signature = `amount=${amount}&cancelUrl=${cancelUrl}&description=${description}&orderCode=${orderCode}&returnUrl=${returnUrl}`
        let hmac = crypto.createHmac('sha256', config.payOS.checksumKey)
        hmac.update(signature)
        let signatureHash = hmac.digest('hex')
        return signatureHash
    }
}

export default PaymentService